import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import './PageRankingHistorico.css';

const data = [
  { categoria: 'BANCOS',                              ranks: [1,  1,  1,  1,  2,  2]  },
  { categoria: 'LOTERIAS/PRONOSTICOS/SORTEOS',        ranks: [2,  7,  6,  2,  24, 18] },
  { categoria: 'TIENDAS DEPARTAMENTALES',              ranks: [3,  2,  4,  7,  8,  8]  },
  { categoria: 'SERVICIOS DE TELEFONIA CELULAR',       ranks: [4,  3,  2,  3,  4,  3]  },
  { categoria: 'COMIDAS RAPIDAS',                      ranks: [5,  4,  3,  4,  5,  5]  },
  { categoria: 'FARMACIAS',                            ranks: [6,  8,  null, 17, null, null] },
  { categoria: 'PROSELITISMO POLITICO',                ranks: [7,  null, null, null, 3,  null] },
  { categoria: 'SUPERMERCADOS/TIENDAS DE AUTOSERVICIO', ranks: [8,  6,  5,  9,  7,  7]  },
  { categoria: 'GOBIERNO/CAMPANAS GUBERNAMENTALES',    ranks: [9,  5,  7,  6,  1,  1]  },
  { categoria: 'ESPECTACULOS',                         ranks: [10, 14, 13, 12, null, null] },
  { categoria: 'OPERADORES DE CABLE',                  ranks: [11, 13, 22, 10, 10, 11] },
  { categoria: 'ASOCIACIONES CIVILES EMPRESARIALES',   ranks: [12, 20, 21, 20, 12, 15] },
  { categoria: 'TIENDAS VENTAS DE CAFE',               ranks: [13, 16, 15, 24, 21, 21] },
  { categoria: 'ANALGESICOS',                          ranks: [14, 10, 8,  5,  6,  16] },
  { categoria: 'FUNDACIONES',                          ranks: [15, 9,  9,  22, 20, 13] },
  { categoria: 'MEDICAMENTOS VARIOS',                  ranks: [16, 12, 10, 14, 18, 10] },
  { categoria: 'COMUNICACION ELECTRONICO/INTERNET',    ranks: [17, 18, 19, 23, null, null] },
  { categoria: 'AUTOPROMOCIONAL DE CANALES TV',        ranks: [18, null, 23, null, 16, 6] },
  { categoria: 'TRANSFERENCIA DE FONDOS',              ranks: [19, 11, 11, 13, 11, 9]  },
  { categoria: 'RECONSTITUYENTES',                     ranks: [20, 19, null, null, 19, 25] },
  { categoria: 'SUEROS',                               ranks: [21, null, 25, null, null, null] },
  { categoria: 'ACEITES COMESTIBLES/ANTIADHERENTES',   ranks: [22, null, null, null, null, null] },
  { categoria: 'COUGH & COLD',                         ranks: [23, 15, 14, 21, 14, 14] },
  { categoria: 'SHAMPOOS/ACONDICIONADORES',            ranks: [24, 21, null, 8,  9,  4]  },
  { categoria: 'REPUESTOS AUTOS',                      ranks: [25, null, null, null, null, null] },
];

const years = [2025, 2024, 2023, 2022, 2021, 2020];

function getRankClass(rank) {
  if (rank === null) return 'rank-out';
  if (rank <= 3) return 'rank-top3';
  if (rank <= 10) return 'rank-top10';
  if (rank <= 25) return 'rank-top25';
  return 'rank-out';
}

function getTrendIcon(ranks) {
  const r2025 = ranks[0];
  const r2024 = ranks[1];
  if (r2024 === null) return { icon: 'NEW', cls: 'trend-new' };
  if (r2025 < r2024) return { icon: '\u25B2', cls: 'trend-up' };
  if (r2025 > r2024) return { icon: '\u25BC', cls: 'trend-down' };
  return { icon: '\u25CF', cls: 'trend-same' };
}

function PageRankingHistoricoCat() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="ranking-page">
        <header className="ranking-header">
          <button className="btn-back" onClick={() => navigate('/top25-categorias')}>
            &#8592; Top 25
          </button>
          <div className="ranking-title-block">
            <h1 className="ranking-title">Ranking Hist&oacute;rico</h1>
            <p className="ranking-subtitle">Evoluci&oacute;n de posici&oacute;n &middot; Top 25 Categor&iacute;as 2025 &middot; Honduras</p>
          </div>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <div className="ranking-legend">
          <span className="legend-item"><span className="legend-dot legend-top3"></span>Top 3</span>
          <span className="legend-item"><span className="legend-dot legend-top10"></span>Top 10</span>
          <span className="legend-item"><span className="legend-dot legend-top25"></span>Top 25</span>
          <span className="legend-item"><span className="legend-dot legend-out"></span>Fuera del Top 25</span>
        </div>

        <div className="ranking-table-wrapper">
          <table className="ranking-table">
            <thead>
              <tr>
                <th className="rk-col-pos">#</th>
                <th className="rk-col-name">Categor&iacute;a</th>
                <th className="rk-col-trend"></th>
                {years.map(y => (
                  <th key={y} className={`rk-col-year ${y === 2025 ? 'rk-col-current' : ''}`}>{y}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => {
                const trend = getTrendIcon(row.ranks);
                return (
                  <tr key={idx} className="rk-row" style={{ animationDelay: `${idx * 0.04}s` }}>
                    <td className="rk-col-pos">
                      <span className="rk-pos-badge">{idx + 1}</span>
                    </td>
                    <td className="rk-col-name">{row.categoria}</td>
                    <td className="rk-col-trend">
                      <span className={`trend-badge ${trend.cls}`}>{trend.icon}</span>
                    </td>
                    {row.ranks.map((rank, i) => (
                      <td key={i} className={`rk-col-year ${years[i] === 2025 ? 'rk-col-current' : ''}`}>
                        <span className={`rank-cell ${getRankClass(rank)}`}>
                          {rank !== null ? rank : '-'}
                        </span>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageRankingHistoricoCat;
